const STRIP_COMMENTS = /((\/\/.*$)|(\/\*.*\*\/))/mg;
const STRIP_KEYWORDS = /(\s*async\s*|\s*function\s*)+/;
const ARGUMENT_NAMES = /\(([^)]+)\)\s*=>|([a-zA-Z_$]+)\s*=>|[a-zA-Z_$]+\(([^)]+)\)|\(([^)]+)\)/;
const ARGUMENT_SPLIT = /[ ,\n\r\t]+/;

export function getArgNames(func) {

  if(func.toString){
    func = func.toString();
  }

  func = func
        .replace(STRIP_COMMENTS, '')
        .replace(STRIP_KEYWORDS, '')
        .trim();
    const matches = ARGUMENT_NAMES.exec(func);
    var match;
    if (matches) {
        for (var i = 1; i < matches.length; i++) {
            if (matches[i]) {
                match = matches[i];
                break;
            } 
        }
    }

    if (match === undefined) {
        return [];
    }

    return match.split(ARGUMENT_SPLIT).filter(part => part !== '');
}


export function executeFunction(func, args, me){
  if(!func.args){
    func.args = getArgNames(func);
  }

  return func.apply(me,func.args.map(arg=>args[arg]));
}